import { timeSeriesResponseSchema } from "./schemas.js";
import { doPost, toUrl, getSearchQuery } from "./lib.js";
export async function graphTimeSeries(clientInfo, input) {
  const url = toUrl(clientInfo.orgId, "graph/timeseries");
  const json = await doPost(url, clientInfo, getSearchQuery(input));
  return timeSeriesResponseSchema.parse(json);
}
